/* fenou Mini Cart — "Angebot des Monats" Add-to-Cart Handler + Discount-Code Apply */
(function () {
  /* Discount-Code Apply via /discount/CODE Cookie + cart:refresh — kein Page-Reload */
  document.addEventListener('submit', async function (e) {
    if (!e.target.matches('[data-fenou-discount-form]')) return;
    e.preventDefault();
    var input = e.target.querySelector('input[name="discount"]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }
    var btn = e.target.querySelector('.fenou-cart-discount__submit');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }

    try {
      await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: true }
      }));
      input.value = '';
    } catch (err) {
      /* Silent fail — Shopify ignoriert ungültige Codes ohnehin */
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    }
  });


  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-fenou-offer-cta]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('[data-fenou-offer-form]');
    if (!form || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    var original = btn.textContent;
    btn.textContent = btn.dataset.i18nLoading || 'Wird hinzugefügt…';

    try {
      var fd = new FormData(form);
      var variantId = parseInt(fd.get('id'), 10);
      var quantity = parseInt(fd.get('quantity') || '1', 10);
      if (!variantId) throw new Error('missing variant');

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      });
      if (!res.ok) throw new Error('add failed');

      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: true }
      }));
    } catch (err) {
      btn.textContent = btn.dataset.i18nError || 'Fehler – erneut versuchen';
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }, 2000);
    }
  });
})();
